import { motion } from 'framer-motion';
import { gEnums } from 'global/enums/globalEnums';
import Wrapper from 'global/wrappers/Wrapper';
import { useState } from 'react';
import { _swiperMenuTypes, SwiperMenu } from './SwiperMenu';
import CardSponsor from '../sem/cards/CardSponsor';

export const MiniSwiper = ({
  swipeItems,
  className = '',
  handleActiveKey,
  topper,
  other,
  noMid,
}) => {

  const [activeIndex, setActiveIndex] = useState(0);

  const handleIndexChange = (index) => {
    setActiveIndex(index);
    handleActiveKey && handleActiveKey(index, swipeItems?.[index]?.key)
  };

  const header = <SwiperMenu
    swipeContentType={gEnums.swipeContentTypes.normalItems}
    menuItems={swipeItems}
    swiperMenuType={_swiperMenuTypes.buttons}
    activeIndex={activeIndex}
    handleIndexChange={handleIndexChange}
  />

  const content = <div
    className={`mini-swiper ${className}`}
    style={{
      position: 'relative',
    }}
  >
    {swipeItems.map((item, index) => (
      <motion.div
        key={index}
        initial={false}
        animate={{
          opacity: activeIndex === index ? 1 : 0,
          display: activeIndex === index ? 'block' : 'none',
        }}
        transition={{ duration: 0.15, ease: 'easeInOut' }}
      >
        {item ? item.content : <div>---</div>}
      </motion.div>
    ))}
    {other && other}
  </div>

  return (
    <Wrapper
      header={header}
      search={topper}
      content={content}
      noMid={noMid}
    />
  )
} 